import { use, useState } from "react";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../../firebase";
import Navbar from "../../Components/Navbar/Navbar"
import Footer from "../../Components/Footer/Footer";
import "./Login.css"


export default function Login() {
const [email, setEmail] = useState("");
const [pw, setPw] = useState("");
const [err, setErr] = useState("");
const [info,setInfo] = useState("");
const [loading, setLoading] = useState(false);
const nav = useNavigate();

async function handleSubmit(e) {
e.preventDefault();
setErr("");
setLoading(true);
try {
    await signInWithEmailAndPassword(auth, email.trim(), pw);
    nav("/dashboard");
} catch (e) {
    setErr(e.message);
}
setLoading(false);
}

async function handleForgot(e) {
    e.preventDefault();
    setErr("");
    setInfo("");
    const addr = email.trim();
    if (!addr){
        setErr("Enter your email above to reset your password.");
        return;
    }
    try{
        await sendPasswordResetEmail(auth, addr);
        setInfo("Password reset email sent. Please Check your inbox.");
    }catch(e){
        setErr(e.message);
    }
}

return (
    <>
        <Navbar/>
        <div className="auth-container">
            
            <div className="auth-card">
            <h2>Log in</h2>
            {err && <div className="auth-error">{err}</div>}
            <form onSubmit={handleSubmit}>
                <label>Email</label>
                <input type="email" value={email} onChange={e=>setEmail(e.target.value)} required />
                <label>Password</label>
                <input type="password" value={pw} onChange={e=>setPw(e.target.value)} required />
                <button type="button" className="forget-password" onClick={handleForgot}>Forget Password?</button>
                <button className="Login-Button" disabled={loading}>{loading ? "…" : "Log in"}</button>
            </form>
            <p className="auth-switch">
                No account? <Link to="/signup">Sign up</Link>
            </p>
            </div>
        </div>
        <Footer/>
    </>

);
}
